import { OrderGroupModel } from "../pages/shared/models/order/orderGroupModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function createGroup(group: OrderGroupModel) {
  const authorizationHeader = configAuthorizationHeader();

  return axiosInstance.post(
    `${API_URL}/orders-group/create`,
    serializeValues(group),
    authorizationHeader,
  );
}

async function editGroup(groupId: number, group: any) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/orders-group/${groupId}`,
        serializeValues(group),
        authorizationHeader,
      )
      .then((response) => response?.data as GroupUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function getGroups(
  filter: object,
  page: number,
  limit: number,
): Promise<GroupsResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .post(
        `${API_URL}/orders-groups?page=${page}&limit=${limit}`,
        { filter },
        authorizationHeader,
      )
      .then((response) => response?.data as GroupsResponseModel);
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      groups: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getGroupById(groupId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/orders-group/${groupId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function deleteGroupById(groupId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/orders-group/${groupId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

function serializeValues(group: OrderGroupModel) {
  const groupClone: { [key: string]: any } = JSON.parse(JSON.stringify(group));

  if (groupClone.destination) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    groupClone.destination = groupClone.destination.warehouseId;
  }
  if (groupClone.orders.length) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    groupClone.orders = groupClone.orders.map((order) => order.orderId);
  }

  return groupClone;
}

export default {
  createGroup,
  editGroup,
  getGroups,
  getGroupById,
  deleteGroupById,
};

export interface GroupsResponseModel {
  currentPage: number;
  groups: OrderGroupModel[];
  pageSize: number;
  totalItems: number;
}

export interface GroupUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
